export enum PrintLayoutEnum {
  A4 = 'A4',
  A3 = 'A3',
}
